angular.module('cwel').factory('addOne', () => {
    return {
        increment: (num) => {
            return num + 1;
        },
    };
});



// WEBPACK FOOTER //
// ./cwel/service/add-one/add-one.es